import PropTypes from "prop-types"
import React, { useState } from "react"
import { Row, Card, CardBody, Container, Spinner } from "reactstrap"

//redux
import { useDispatch } from "react-redux"

import { Link } from "react-router-dom"

// availity-reactstrap-validation
import { AvForm, AvField } from "availity-reactstrap-validation"

// action
import { resetPassword } from "../../store/actions"

// import images
import MetaTag from "components/Common/Meta-tag"
import { LocalLogo } from "assets/images"
import {
  useHistory,
  useParams,
} from "react-router-dom/cjs/react-router-dom.min"

const ResetPasswordPage = props => {
  const dispatch = useDispatch()
  const history = useHistory()
  const params = useParams()
  const [show, setShow] = useState(false)
  const [password, setPassword] = useState({
    pass: "",
    confirmPass: "",
  })

  function handleValidSubmit(event, values) {
    const user = {
      ...values,
    }
    dispatch(resetPassword(user, params?.id, history))
  }
  const loading = false

  const settings = []

  return (
    <React.Fragment>
      <MetaTag title="Reset password" />

      <div className="home-btn d-none d-sm-block">
        <Link to="/" className="text-dark">
          <i className="fas fa-home h2" />
        </Link>
      </div>
      <div className="account-pages my-5 pt-sm-5">
        <Container>
          <Row className="justify-content-center">
            <Card className="login-old">
              <CardBody className="p-0 d-flex w-100 align-items-center justify-content-center">
                <div className="p-4 w-100 sm:w-100">
                  <Link to="/" className="auth-logo-light">
                    <div className="d-flex align-items-center justify-content-center">
                      <span
                        className="avatar-title py-3"
                        style={{
                          backgroundColor: "transparent",
                          justifyContent: "flex-start",
                          marginLeft: "",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "start",
                        }}
                      >
                        <img
                          src={settings?.company?.logo[0]?.url ?? LocalLogo}
                          alt="logo"
                          height="80"
                        />
                      </span>
                    </div>
                  </Link>
                  <p>Create New Password to login ...</p>
                  <AvForm
                    className="form-horizontal"
                    onValidSubmit={(e, v) => {
                      handleValidSubmit(e, v)
                    }}
                  >
                    <div className="mb-3">
                      <AvField
                        name="newPassword"
                        label="Password"
                        className="form-control"
                        placeholder="Enter password"
                        type={show ? "text" : "password"}
                        onChange={e =>
                          setPassword({
                            ...password,
                            pass: e.target.value,
                          })
                        }
                        validate={{
                          required: {
                            value: true,
                            errorMessage: "Password is Required",
                          },
                          minLength: {
                            value: 4,
                            errorMessage: "Minimum four characters",
                          },
                        }}
                      />
                    </div>

                    <div className="mb-3">
                      <AvField
                        name="confirmPassword"
                        label="Confirm                   Password"
                        type={show ? "text" : "password"}
                        placeholder="Confirm Password"
                        validate={{
                          required: {
                            value: true,
                            errorMessage: "Confirm Password is Required",
                          },
                          pattern: {
                            value:
                              password?.pass !== password?.confirmPass
                                ? "^(?=.*[a-z])(?=.*[A-Z])(?=.*d)(?=.*[@$!%*?&])[A-Za-zd@$!%*?&]{8,10}$"
                                : "",
                            errorMessage: "Password does not match",
                          },
                        }}
                        onChange={e =>
                          setPassword({
                            ...password,
                            confirmPass: e.target.value,
                          })
                        }
                      />
                    </div>

                    <div className="form-check">
                      <input
                        type="checkbox"
                        className="form-check-input"
                        id="customControlInline"
                        onChange={e => setShow(e.target.checked)}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="customControlInline"
                      >
                        Show Password
                      </label>
                    </div>

                    <div className="mt-3 d-grid">
                      <button
                        style={{
                          backgroundColor: "#2784ff",
                          color: "white",
                        }}
                        className="btn  btn-block"
                        type="submit"
                      >
                        {loading ? (
                          <>
                            <Spinner color="white" />
                          </>
                        ) : (
                          "Create Password"
                        )}
                      </button>
                    </div>
                  </AvForm>
                </div>
              </CardBody>
            </Card>
            {/* </Card> */}
            <div className="mt-5 text-center">
              <p>
                © {new Date().getFullYear()} { }. Crafted with{" "}
                <i className="mdi mdi-heart text-danger" /> by
                <a target="blank" href="https://osperb.com">
                  {` osperb`}
                </a>
              </p>
            </div>
            {/* </Col> */}
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

ResetPasswordPage.propTypes = {
  history: PropTypes.object,
}

export default ResetPasswordPage
